import { initialState } from "./state"
import { getOptimizedImage } from "@/helpers"

const withLogo = (podcast) => ({
  ...podcast,
  logo: podcast.image?.length
    ? getOptimizedImage(`https://${podcast.image}?u=${Date.now()}`, 170, 170)
    : false,
})

export const setPodcasts = (state, payload) => {
  state.podcasts = payload.map(withLogo)
}

export const setPodcast = (state, payload) => {
  state.podcast = withLogo(payload)
}

export const resetPodcast = (state) => {
  state.podcast = initialState().podcast
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
